/* tslint:disable:max-line-length */
import { AppleOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import React from 'react';
import { LLRActionButtons } from '../LLRActionButtons/LLRActionButtons';
import {
  beautifyNumber,
  WEB_TRAFFIC_GROWTH_WITH_MOBILEMONKEY,
} from '../WebsiteReportSummary/constants';
import arrow1 from './arrows/arrow1.png';
import arrow2 from './arrows/arrow2.png';
import arrow3 from './arrows/arrow3.png';
import arrow4 from './arrows/arrow4.png';
import styles from './MotivationalBlock.module.css';

const Meta = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
  >
    <path
      d="M9.83868 6.88783C5.99874 6.88783 3.05762 11.8854 3.05762 17.17C3.05762 20.4782 4.65759 22.5676 7.3399 22.5676C9.26928 22.5676 10.6575 21.6593 13.128 17.3441C13.128 17.3441 14.1586 15.5277 14.8645 14.2759L16.3327 11.7913C17.5797 9.8666 18.6103 8.90662 19.8338 8.90662C22.3749 8.90662 24.4079 12.6477 24.4079 17.2453C24.4079 18.9959 23.8337 20.0123 22.6432 20.0123C21.5044 20.0123 20.9585 19.2594 18.7938 15.7771L16.8033 17.5135C19.0574 21.2876 20.3138 22.5676 22.5914 22.5676C25.2031 22.5676 26.6572 20.4453 26.6572 17.0665C26.6572 11.5278 23.6502 6.87842 19.9938 6.87842C18.0597 6.87842 16.5445 8.33722 15.1751 10.1866L13.6551 12.4171C12.1539 14.723 11.241 16.1677 11.241 16.1677C9.24104 19.3064 8.54929 20.0076 7.43402 20.0076C6.2858 20.0076 5.60816 19.0006 5.60816 17.2077C5.60816 13.3677 7.52343 9.44308 9.80574 9.44308L9.83868 6.88783Z"
      fill="#262626"
    />
    <path
      d="M15.3021 11.9228L13.6551 12.4311C12.1539 14.7369 11.241 16.1816 11.241 16.1816C9.24104 19.3204 8.54929 20.0215 7.43402 20.0215C6.2858 20.0215 5.60816 19.0145 5.60816 17.2216C5.60816 13.3816 7.52343 9.457 9.80574 9.457L9.83868 6.89234C5.99874 6.88763 3.05762 11.8854 3.05762 17.17C3.05762 20.4782 4.65759 22.5676 7.3399 22.5676C9.26928 22.5676 10.6575 21.6593 13.128 17.3441C13.128 17.3441 14.1586 15.5277 14.8645 14.2759L15.3021 11.9228Z"
      fill="#262626"
    />
    <path
      d="M16.8032 17.5179C19.0573 21.2919 20.3138 22.5676 22.5914 22.5676L22.6432 20.0123C21.5044 20.0123 20.9584 19.2637 18.7938 15.7814C16.9773 12.8262 16.0503 11.3486 15.175 10.1956C13.2927 7.80038 11.721 6.88783 9.83868 6.88783L9.80566 9.45211C11.0433 9.45211 12.0739 10.1676 13.6551 12.4311C14.3186 13.3628 15.6785 15.5791 16.8032 17.5179Z"
      fill="#262626"
    />
    <path
      d="M15.1706 10.1956C13.2882 7.80038 11.7165 6.88745 9.82947 6.88745C7.97068 6.88745 6.32365 8.0592 5.11426 9.86623L6.9307 11.725C7.68833 10.3556 8.70929 9.457 9.80574 9.457C11.0434 9.457 12.0647 10.1627 13.6459 12.4262L15.1706 10.1956Z"
      fill="#262626"
    />
    <path
      d="M18.0547 19.4947C19.6029 21.7488 20.7703 22.5676 22.5914 22.5676C25.2031 22.5676 26.6572 20.4453 26.6572 17.0665L24.4079 17.2453C24.4079 18.9959 23.8337 20.0123 22.6432 20.0123C21.7255 20.0123 21.1888 19.523 19.8758 17.4995L18.0547 19.4947Z"
      fill="#262626"
    />
  </svg>
);

const Klaviyo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
  >
    <path
      d="M25.9625 22.0797H2.76758V6.66968H25.9625L21.4744 13.8444L21.1426 14.3747L21.4744 14.905L25.9625 22.0797Z"
      stroke="#262626"
      strokeWidth="2"
    />
  </svg>
);

export const MotivationalBlock = ({
  websiteURL,
  totalTraffic,
  onClick,
  isWhiteLabel,
}: {
  websiteURL: string;
  totalTraffic: number;
  onClick: () => void;
  isWhiteLabel?: boolean;
}) => {
  const additionalLeads = beautifyNumber(
    totalTraffic * WEB_TRAFFIC_GROWTH_WITH_MOBILEMONKEY,
  );
  const points = [
    {
      icon: Klaviyo,
      title: 'Add them to your email lists',
    },
    {
      icon: Meta,
      title: 'Sync them to retargeting audiences',
    },
    {
      icon: <AppleOutlined className={styles.icon} />,
      title: 'Attribute sales to clicks (Beat iOS 14)',
    },
    {
      icon: <UsergroupAddOutlined className={styles.icon} />,
      title: 'Create high converting lookalike audiences',
    },
  ];
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.heading}>
          {isWhiteLabel ? 'We' : 'Customers.ai'} could have collected the emails
          of an
          {''}{' '}
          <span className={styles.highligted}>
            additional {''}
            {additionalLeads}
          </span>
          {''} people who visited {''}
          <span className={styles.url}>{websiteURL}</span>
          {''} this month
        </div>
        <div className={styles.arrows}>
          <img src={arrow1} />
          <img src={arrow2} />
          <img src={arrow3} />
          <img src={arrow4} className={styles.arrowFour} />
        </div>
        <div className={styles.pointsWrapper}>
          {points.map(point => (
            <div className={styles.point} key={point.title}>
              {point.icon}
              {point.title}
            </div>
          ))}
        </div>
      </div>
      {!isWhiteLabel && (
        <LLRActionButtons onClick={onClick} websiteURL={websiteURL} />
      )}
    </div>
  );
};
